import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import '@/plugins/vuetify-mask'
import router from './router'
import 'typeface-roboto/index.css'
import App from './App'
import moment from 'moment'
import VueMask from 'v-mask'
import './plugins/vuetify-money.js'
import SnackControl from '@helper/snackControl'
import Formatter from '@helper/formatter'
import Permissions from '@helper/permissions'
import Printer from '@helper/printer'

import LeafletHeatmap from './components/graficos/Vue2LeafletHeatmap'
import { LMap, LTileLayer, LMarker, LControl, LPopup, LLayerGroup } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false
Vue.component('LeafletHeatmap', LeafletHeatmap)
Vue.component('l-map', LMap)
Vue.component('l-popup', LPopup)
Vue.component('l-layer-group', LLayerGroup)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-control', LControl)
moment.locale('pt-br')
Vue.use(VueMask)
/* eslint-disable no-new */
Vue.use({
  vuetify
})
new Vue({
  el: '#app',
  router,
  vuetify,
  data: {
    snackbar: {
      show: false,
      text: '',
      time: 5000,
      color: 'success'
    },
    Printer,
    printerControl: {
      show: false,
      data: null
    },
    SnackControl,
    Permissions,
    Formatter
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js